import $ from 'jquery';

function getSettingList(serverUrl) {
  let ajax_param = {
    url: serverUrl + '/api/operation/setting_list/',
    type: 'GET',
    cache: false,
    dataType: 'json',
    data: null,
    traditional: true
  };
  let jqxhr = $.ajax(ajax_param).fail(function (jqXHR, textStatus, errThrown) {
    console.error(textStatus, errThrown.toString());
    alert(
      'ご迷惑をおかけして、大変申し訳ございません。 \nサーバへのアクセスが大変混み合っており、 ページを表示することができません。 '
    );
  });
  return jqxhr;
}

export {getSettingList};
